import {IPress} from "../dc-press/dc-press.decl";

export interface IPressAPIRequest {
    topic: string[]
    contentType: string[]
    dateRange: string
    page: number
    itemsPerPage: number
}

export interface IPressAPIResponse {
    press: IPress[]
    stats: Record<string, Record<string, number>>
    totalResultCount: number
}

export const pressFilterAPIIDMap: Readonly<{ [K in keyof IPressAPIRequest]: Readonly<string> }> = {
    topic: 'topicFilter',
    contentType: 'contentTypeFilter',
    dateRange: 'dateFilter',
    page: 'page',
    itemsPerPage: 'itemsPerPage',
} as const;

/**
 * New object swapping key and value from <i>pressFilterAPIIDMap</i>
 */
export const apiIdPressFilterMap: Readonly<{ [apiId: string]: Readonly<keyof IPressAPIRequest> }> =
    Object.fromEntries(
        Array.from(Object.entries(pressFilterAPIIDMap))
            .map(kv => [kv[1], kv[0]])
    ) as { [apiId: string]: Readonly<keyof IPressAPIRequest> };

export interface IPressFilters {
    topicFilter: string[]
    contentTypeFilter: string[]
    dateFilter: string[]
}

export const pageSizes = [10, 25, 50];
